import theme from "lib/theme/theme";
import { SxObjType } from "lib/theme/types/SxObjType.type";

const sxStyles = () => {
  return {
    receiptSection: { padding: theme.spacing(1, 0) },
    receiptPanel: {
      display: "flex",
      // padding: theme.spacing(0, 1),
      alignItems: "flex-start",
    },
    payPanel: {
      display: "flex",
      alignItems: "center",
      borderTop: "1px solid " + theme.palette.secondary.light,
      borderBottom: "1px solid " + theme.palette.secondary.light,
    },
    leftBox: {
      width: "100%",
    },
    rightBox: {
      width: "100%",
    },
    title: {
      color: theme.palette.text.primary,
      paddingTop: theme.spacing(1),
      typography: theme.typography.caption1_semibold,
      width: "100%",
    },
    content: {
      color: theme.palette.grey[600],
      typography: theme.typography.caption1_semibold,
      width: "100%",
    },
    payTitle: {
      typography: theme.typography.body2_semibold,
      width: "100%",
      color: theme.palette.text.primary,
      my: theme.spacing(2),
    },
    payValue: {
      color: theme.palette.warning.main,
      typography: theme.typography.header4_semibold,
      width: "100%",
    },
  } satisfies SxObjType;
};

export { sxStyles };
